import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
    getAllWishlists,
    add,
    updateWishListName,
} from '../Services/WishList.service';
import { translate } from '../Services/translation';
import { catchError } from '../Actions/Error.action';

class WishListAdd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showCreateWishlist: false,
            wishlistName: '',
            wishlists: null,
            edit: false,
            editWishlistCurrentName: '',
            editWishlistNewName: '',
        };
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        this.setState.wishlists = this.props.getAllWishlists();
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleEdit(name) {
        this.setState({
            edit: true,
            editWishlistCurrentName: name,
            editWishlistNewName: name,
        });
    }

    addWishlistName(evt) {
        const val = evt.target.value;
        this.setState({
            wishlistName: val,
        });
    }

    updateEditWishlist(evt) {
        const val = evt.target.value;
        this.setState({
            editWishlistNewName: val,
        });
    }

    async handleAddToWishlist(wishlistName, articleNumber) {
        await this.props.addToWishlist(wishlistName, articleNumber);
        this.props.getAllWishlists();
        this.props.onClose();
    }

    async handleAddWishlist(wishlistName) {
        await this.props.addNewWishlist(wishlistName, this.props.articleNumber);
        this.setState({
            showCreateWishlist: false,
        });
        this.props.getAllWishlists();
        this.props.onClose();
    }

    async handleUpdateWishlistName() {
        await this.props.updateWishlistName(
            this.state.editWishlistCurrentName,
            this.state.editWishlistNewName
        );
        this.props.getAllWishlists();
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.props.onClose();
        }
    }

    render() {
        const { wishList } = this.props;
        const { payload } = wishList;

        return (
            <Fragment>
                <div className="wishlist-add">
                    <div className="wishlist-add__info">
                        <div
                            className="wishlist-add__content"
                            ref={this.setWrapperRef}
                        >
                            <div className="wishlist-add__content__close">
                                <span
                                    className="wishlist-add__content__close__close-button"
                                    onClick={() => this.props.onClose()}
                                ></span>
                            </div>
                            <div className="wishlist-add__content__top">
                                <p className="wishlist-add__content__top__title">
                                    {this.state.edit
                                        ? translate('wishlist.add.edit.title')
                                        : this.state.showCreateWishlist
                                        ? translate('wishlist.add.create.title')
                                        : translate('wishlist.add.title')}
                                </p>
                                <button
                                    type="submit"
                                    className="button wishlist-add__content__top__button"
                                    onClick={() =>
                                        this.setState(() => ({
                                            showCreateWishlist: true,
                                            edit: false,
                                        }))
                                    }
                                >
                                    {translate('wishlist.add.addnew')}
                                </button>
                            </div>

                            {payload && payload.updateWishlistName && (
                                <div>{payload.updateWishlistName.message}</div>
                            )}
                            {payload && payload.addNewWishlist && (
                                <div>{payload.addNewWishlist.message}</div>
                            )}

                            {this.state.showCreateWishlist && (
                                <div className="wishlist-add__content__edit">
                                    <input
                                        className="wishlist-add__form-input"
                                        id="wishlist-name"
                                        name="name"
                                        type="text"
                                        placeholder={translate(
                                            'wishlist.add.inputplaceholder'
                                        )}
                                        value={this.state.wishlistName}
                                        onChange={(evt) =>
                                            this.addWishlistName(evt)
                                        }
                                    />
                                    <div className="wishlist-add__content__edit__button-wrapper">
                                        <button
                                            type="submit"
                                            className="button button--cancel"
                                            onClick={() =>
                                                this.setState(() => ({
                                                    showCreateWishlist: false,
                                                }))
                                            }
                                        >
                                            {translate('wishlist.cancel')}
                                        </button>
                                        <button
                                            type="submit"
                                            className="button button--submit"
                                            onClick={() => {
                                                this.handleAddWishlist(
                                                    this.state.wishlistName,
                                                    this.props.articleNumber
                                                );
                                            }}
                                        >
                                            {translate('wishlist.save')}
                                        </button>
                                    </div>
                                </div>
                            )}

                            {this.state.edit && (
                                <div className="wishlist-add__content__edit">
                                    <input
                                        className="wishlist-add__form-input"
                                        id="wishlist-name"
                                        name="name"
                                        type="text"
                                        value={this.state.editWishlistNewName}
                                        onChange={(evt) =>
                                            this.updateEditWishlist(evt)
                                        }
                                    />
                                    <div className="wishlist-add__content__edit__button-wrapper">
                                        <button
                                            type="submit"
                                            className="button button--cancel"
                                            onClick={() =>
                                                this.setState({
                                                    edit: false,
                                                })
                                            }
                                        >
                                            {translate('wishlist.cancel')}
                                        </button>
                                        <button
                                            type="submit"
                                            className="button button--submit"
                                            onClick={() => {
                                                this.handleUpdateWishlistName();
                                                this.setState({
                                                    edit: false,
                                                });
                                            }}
                                        >
                                            {translate('wishlist.save')}
                                        </button>
                                    </div>
                                </div>
                            )}
                            {wishList &&
                                !this.state.showCreateWishlist &&
                                !this.state.edit && (
                                    <div className="wishlist-add__content__lists__container">
                                        {wishList.lists &&
                                            wishList.lists.map(
                                                (list, index) => (
                                                    <div
                                                        key={`wishlist-list-item-${index}`}
                                                        className="wishlist-add__content__lists__item"
                                                    >
                                                        <p
                                                            className="wishlist-add__content__lists__item__text"
                                                            onClick={() =>
                                                                this.handleAddToWishlist(
                                                                    list.name,
                                                                    this.props
                                                                        .articleNumber
                                                                )
                                                            }
                                                        >
                                                            {list.name}
                                                        </p>
                                                        <button
                                                            className="wishlist-add__content__lists__item__edit"
                                                            onClick={() => {
                                                                this.handleEdit(
                                                                    list.name
                                                                );
                                                            }}
                                                            title={translate(
                                                                'wishlist.add.edit'
                                                            )}
                                                        ></button>
                                                    </div>
                                                )
                                            )}
                                    </div>
                                )}
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

const loadError = (error) => ({
    type: 'WISHLIST_LOAD_ERROR',
    payload: {
        error,
    },
});

const mapStateToProps = (state) => {
    return {
        wishList: state.wishList,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAllWishlists: () => dispatch(getAllWishlists()),
        addToWishlist: (name, articleNumber) => add(name, articleNumber),
        updateWishlistName: (previousName, newName) =>
            dispatch(updateWishListName(previousName, newName)),
        addNewWishlist: (wishlistName, articleNumber) =>
            add(wishlistName, articleNumber, 1),
        onError: (ex) => {
            dispatch(catchError(ex, (error) => loadError(error)));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WishListAdd);
